import {Map} from 'immutable';
import TwoWayQuestionV2 from './V2/TwoWayQuestion.react';
import TwoWayQuestionExplanation from './V2/TwoWayQuestionExplanation.react';
import TwoWayQuestionResponseStats from './V2/TwoWayQuestionResponseStats.react';
import TwoWayEditor from './TwoWayEditor.react';

export const TwoWayQuestionType = new Map({
  type: 'two-way',
  label: 'Two Way',
  questionRenderer: TwoWayQuestionV2,
  explanationRenderer: TwoWayQuestionExplanation,
  responseStatsRenderer: TwoWayQuestionResponseStats,
  editor: TwoWayEditor,
  isHidden: false
});
